export function Accordion() {
    document.addEventListener('DOMContentLoaded', () => {
        // Natywny name-accordion (<details name>) zamyka rodzeństwo przy otwarciu
        // kolejnego panelu. Wszystkie akordeony w projekcie mają atrybut name,
        // więc to selektor wystarczający (faq-list, expandable-list, grouped-list).
        const items = document.querySelectorAll('details[name]');
        if (!items.length) return;

        // Panel ma wylądować tuż pod sticky headerem. offsetHeight działa też gdy
        // SmartHeader go chowa (translateY nie zmienia wysokości layoutu).
        const headerOffset = () => {
            const header = document.querySelector('[data-smart-header]');
            return (header ? header.offsetHeight : 0) + 24;
        };

        // Ile wysokości zniknie POWYŻEJ otwieranego panelu, gdy rodzeństwo o tym
        // samym name się zwija. Tylko rodzeństwo nad panelem przesuwa jego pozycję;
        // mierzymy na starcie animacji (zwijany element jeszcze ma pełną wysokość).
        const collapsingHeightAbove = (details) => {
            const name = details.getAttribute('name');
            if (!name) return 0;

            const detailsTop = details.getBoundingClientRect().top;
            let total = 0;

            document.querySelectorAll(`details[name="${CSS.escape(name)}"]`).forEach((sibling) => {
                if (sibling === details || sibling.open) return;

                const rect = sibling.getBoundingClientRect();
                if (rect.top >= detailsTop) return;

                const summary = sibling.querySelector(':scope > summary');
                const collapsed = summary ? summary.getBoundingClientRect().height : 0;
                const extra = rect.height - collapsed;
                if (extra > 0) total += extra;
            });

            return total;
        };

        items.forEach((details) => {
            details.addEventListener('toggle', () => {
                if (!details.open) {
                    // Zwinięcie panelu zwija też zagnieżdżone akordeony, żeby po
                    // ponownym otwarciu grupa startowała z zamkniętymi nested.
                    details.querySelectorAll('details[open]').forEach((nested) => {
                        nested.open = false;
                    });
                    return;
                }

                const summary = details.querySelector(':scope > summary');
                if (!summary) return;

                // Jeden synchroniczny scroll, bez easingu i timera. Cel liczymy z góry
                // (pozycja summary − wysokość zwijana powyżej − offset headera), więc po
                // skoku resztę ruchu wygładza natywna animacja zwijania ::details-content,
                // a panel kończy dokładnie pod headerem (bez przestrzelenia).
                const distance = (summary.getBoundingClientRect().top - collapsingHeightAbove(details)) - headerOffset();
                if (Math.abs(distance) >= 1) {
                    window.scrollBy(0, distance);
                }
            });
        });
    });
}